(function () {
  'use strict';

  if (window.CPNSDLaces) return;

  var configNode = document.querySelector('[data-cp-nsd-laces-config]');
  var root = document.querySelector('[data-cp-nsd]');
  if (!configNode || !root) return;

  var config;
  try { config = JSON.parse(configNode.textContent); } catch (error) { return; }

  var STORAGE_KEY = 'cpNsdLaces2026';
  var FREE_PROPERTY = '_nsd_free_lace';
  var state = { cart: null, colour: '', style: '', busy: false, lastFocus: null, opened: false };
  var colourRoot = root.querySelector('[data-cp-nsd-colours]');
  var styleRoot = root.querySelector('[data-cp-nsd-styles]');
  var addButton = root.querySelector('[data-cp-nsd-add]');
  var errorNode = root.querySelector('[data-cp-nsd-error]');
  var imageNode = root.querySelector('[data-cp-nsd-image]');
  var startImage = imageNode ? imageNode.getAttribute('src') : '';
  var claimButtons = document.querySelectorAll('[data-cp-nsd-claim]');
  var variants = Array.isArray(config.variants) ? config.variants : [];
  var marketAllowed = config.marketAllowed === true;

  /* Escape the drawer's inert/transform stacking context. */
  document.body.appendChild(root);
  /* The reopen ("claim") button lives in the mini cart AND on the cart page, each with an "ENDS IN" countdown underneath.
     Both are re-placed on every sync because the theme re-renders the drawer and cart page on cart changes. */
  var claimTemplate = claimButtons[0];
  if (claimTemplate) claimTemplate.remove();
  function makeClaim(slot) {
    var wrap = document.createElement('div');
    wrap.className = 'cp-nsd-claim-wrap'; wrap.setAttribute('data-cp-nsd-claim-wrap', slot); wrap.hidden = true;
    var button = claimTemplate.cloneNode(true); button.hidden = false;
    button.addEventListener('click', function () { open(true); });
    var timer = document.createElement('p'); timer.className = 'cp-nsd-claim__countdown'; timer.setAttribute('data-cp-nsd-countdown', ''); timer.setAttribute('aria-hidden', 'true');
    wrap.appendChild(button); wrap.appendChild(timer);
    return wrap;
  }
  function placeClaims() {
    if (!claimTemplate) return;
    var targets = [
      ['drawer', document.querySelector('#t4s-mini_cart .t4s-drawer__bottom, #t4s-mini_cart [data-cart-wrapper]'), 'prepend'],
      ['page', Array.prototype.find.call(document.querySelectorAll('.t4s-btn-group__checkout-update'), function (node) { return !node.closest('#t4s-mini_cart'); }), 'before']
    ];
    targets.forEach(function (target) {
      var slot = target[0], anchor = target[1];
      if (!anchor) return;
      var parent = target[2] === 'prepend' ? anchor : anchor.parentNode;
      var existing = parent.querySelector('[data-cp-nsd-claim-wrap="' + slot + '"]');
      if (existing) return;
      var wrap = makeClaim(slot);
      if (target[2] === 'prepend') anchor.insertBefore(wrap, anchor.firstChild); else parent.insertBefore(wrap, anchor);
    });
  }

  function clearSession(cart) { try { sessionStorage.removeItem(cartSessionKey(cart || state.cart)); } catch (error) {} }
  function cartSessionKey(cart) { return STORAGE_KEY + ':' + String(cart && cart.token || 'unknown'); }
  function sessionValue(cart) { try { return sessionStorage.getItem(cartSessionKey(cart)) || ''; } catch (error) { return ''; } }
  function setSession(value, cart) { try { sessionStorage.setItem(cartSessionKey(cart || state.cart), value); } catch (error) {} }
  function previewEnabled() { return new URLSearchParams(window.location.search).get('nsd_preview') === 'laces'; }
  function marketDateParts() {
    var parts = new Intl.DateTimeFormat('en-CA', { timeZone: config.timezone, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
    var output = {};
    parts.forEach(function (part) { output[part.type] = part.value; });
    return output.year + '-' + output.month + '-' + output.day;
  }
  function inWindow() { var day = marketDateParts(); return previewEnabled() || day === '2026-10-09' || day === '2026-10-08'; }
  function isFree(item) { return item && item.properties && String(item.properties[FREE_PROPERTY]) === 'true'; }
  function isGiftCard(item) { return item.gift_card === true || /gift\s*card/i.test(String(item.product_type || '')) || /gift-card/i.test(String(item.handle || '')); }
  function hasPaidItem(cart) {
    return !!(cart && cart.items || []).find(function (item) {
      return !isFree(item) && !isGiftCard(item) && Number(item.quantity) > 0 && Number(item.final_line_price) > 0;
    });
  }
  function freeLines(cart) { return (cart && cart.items || []).filter(isFree); }
  function eligible(cart) { return marketAllowed && inWindow() && hasPaidItem(cart); }
  function request(url, options) {
    options = options || {};
    options.credentials = 'same-origin';
    options.headers = Object.assign({ Accept: 'application/json' }, options.headers || {});
    return fetch(url, options).then(function (response) {
      return response.json().then(function (data) { if (!response.ok || data.status >= 400) throw data; return data; });
    });
  }
  function cartRequest() { return request(config.routes.cart); }
  function changeLine(id, quantity) {
    return request(config.routes.change, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: id, quantity: quantity }) });
  }
  function notify(cart) {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { source: 'cp-nsd-laces', cart: cart } }));
    window.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'cp-nsd-laces', cart: cart } }));
  }
  function notifyAndOpenMiniCart(cart) {
    document.dispatchEvent(new CustomEvent('cart:refresh:opend', { bubbles: true, detail: { source: 'cp-nsd-laces', cart: cart } }));
    window.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'cp-nsd-laces', cart: cart } }));
  }
  function enforce(cart) {
    var lines = freeLines(cart);
    var tasks = [];
    if (!eligible(cart)) {
      lines.forEach(function (line) { tasks.push(changeLine(line.key, 0)); });
      if (lines.length || sessionValue(cart) === 'claimed') clearSession(cart);
    } else {
      lines.forEach(function (line, index) {
        if (index > 0) tasks.push(changeLine(line.key, 0));
        else if (Number(line.quantity) !== 1) tasks.push(changeLine(line.key, 1));
      });
    }
    if (!tasks.length) return Promise.resolve(cart);
    return Promise.all(tasks).then(cartRequest).then(function (updated) { notify(updated); return updated; });
  }
  function optionParts(variant) {
    var options = [variant.option1, variant.option2, variant.option3].filter(Boolean);
    var style = options.find(function (value) { return /^(flat|round)$/i.test(value); }) || '';
    if (!style && options.length >= 2 && !/^(upc|ean)$/i.test(options[1])) style = options[1];
    var colour = options.find(function (value) { return value !== style && !/^(upc|ean)$/i.test(value); }) || options[0] || variant.title;
    return { colour: colour.replace(/\s*[|/-]?\s*(UPC|EAN)\s*$/i, '').trim(), style: style || 'Flat' };
  }
  variants.forEach(function (variant) { variant.selection = optionParts(variant); });
  function unique(key) {
    return variants.map(function (variant) { return variant.selection[key]; }).filter(function (value, index, all) { return value && all.indexOf(value) === index; });
  }
  function colourCss(value) {
    var colours = { black: '#111', white: '#fff', grey: '#999', gray: '#999', red: '#c62026', blue: '#214fa3', navy: '#1b2a4a', sky: '#8ec5ea', pink: '#e7a8bb', cream: '#eee2c9', yellow: '#f4cb23', green: '#2e7d32', orange: '#f28c28', brown: '#6d4c41' };
    var parts = String(value).toLowerCase().split(/\s*[\/&+]\s*/).map(function (part) { return colours[part.trim()]; }).filter(Boolean);
    if (parts.length > 1) return 'linear-gradient(135deg, ' + parts[0] + ' 50%, ' + parts[1] + ' 50%)';
    return parts[0] || '#d6d6d6';
  }
  function makeChoice(label, type) {
    var button = document.createElement('button');
    button.type = 'button'; button.className = 'cp-nsd__choice'; button.dataset.value = label; button.setAttribute('aria-pressed', 'false');
    if (type === 'colour') button.innerHTML = '<span class="cp-nsd__swatch" aria-hidden="true"></span>' + escapeHtml(label);
    else button.textContent = label;
    if (type === 'colour') button.style.setProperty('--cp-nsd-colour', colourCss(label));
    button.addEventListener('click', function () { state[type] = label; renderChoices(); });
    return button;
  }
  function escapeHtml(value) { var span = document.createElement('span'); span.textContent = value; return span.innerHTML; }
  function selectedVariant() { return variants.find(function (variant) { return variant.selection.colour === state.colour && variant.selection.style === state.style; }); }
  function renderChoices() {
    var colours = unique('colour');
    if (state.colour && !colours.includes(state.colour)) state.colour = '';
    var allowedStyles = state.colour ? variants.filter(function (variant) { return variant.selection.colour === state.colour; }).map(function (variant) { return variant.selection.style; }) : unique('style');
    if (state.style && !allowedStyles.includes(state.style)) state.style = '';
    if (state.colour && !state.style && allowedStyles.length === 1) state.style = allowedStyles[0];
    colourRoot.innerHTML = ''; styleRoot.innerHTML = '';
    colours.forEach(function (label) { var button = makeChoice(label, 'colour'); button.setAttribute('aria-pressed', String(label === state.colour)); colourRoot.appendChild(button); });
    unique('style').forEach(function (label) { var button = makeChoice(label, 'style'); button.disabled = !allowedStyles.includes(label); button.setAttribute('aria-pressed', String(label === state.style)); styleRoot.appendChild(button); });
    var variant = selectedVariant();
    var preview = variant || (state.colour && variants.find(function (item) { return item.selection.colour === state.colour; }));
    imageNode.src = preview && preview.image ? preview.image : startImage;
    addButton.disabled = !variant || state.busy;
  }
  function showError(message) { errorNode.textContent = message; errorNode.hidden = !message; }
  function close(dismissed) {
    root.hidden = true; state.opened = false; window.CPFreeLaceSelectorActive = false; document.documentElement.classList.remove('cp-nsd-open');
    if (dismissed) setSession('dismissed');
    if (state.lastFocus && state.lastFocus.focus) state.lastFocus.focus();
    syncClaimLink();
  }
  function open(force) {
    if (state.opened) return;
    if (!eligible(state.cart) || freeLines(state.cart).length || (!force && sessionValue(state.cart))) return;
    document.dispatchEvent(new CustomEvent('cp:free-lace-selector:open', { bubbles: true }));
    if (window.jQuery_T4NT && window.jQuery_T4NT.magnificPopupT4s) window.jQuery_T4NT.magnificPopupT4s.close();
    state.colour = ''; state.style = ''; showError(''); state.lastFocus = document.activeElement; root.hidden = false; state.opened = true; window.CPFreeLaceSelectorActive = true; document.documentElement.classList.add('cp-nsd-open');
    renderChoices(); syncClaimLink(); root.querySelector('.cp-nsd__dialog').focus();
  }
  function syncClaimLink() {
    placeClaims();
    var visible = eligible(state.cart) && !freeLines(state.cart).length && !state.opened;
    document.querySelectorAll('[data-cp-nsd-claim-wrap]').forEach(function (wrap) { wrap.hidden = !visible; });
    tickCountdowns();
  }
  function zoneClock() {
    var parts = new Intl.DateTimeFormat('en-CA', { timeZone: config.timezone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
    var v = {}; parts.forEach(function (part) { v[part.type] = part.value; });
    return { day: v.year + '-' + v.month + '-' + v.day, secs: Number(v.hour) * 3600 + Number(v.minute) * 60 + Number(v.second) };
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tickCountdowns() {
    var clock = zoneClock();
    var text = '';
    if (clock.day === '2026-10-09' || previewEnabled()) {
      var left = Math.max(0, 86400 - clock.secs);
      text = String(config.endsLabel || 'ENDS IN') + ' ' + pad(Math.floor(left / 3600)) + ':' + pad(Math.floor(left % 3600 / 60)) + ':' + pad(left % 60);
    }
    document.querySelectorAll('[data-cp-nsd-countdown]').forEach(function (node) { node.textContent = text; node.hidden = !text; });
  }
  function refresh(allowOpen) {
    return cartRequest().then(enforce).then(function (cart) {
      state.cart = cart;
      if (freeLines(cart).length) setSession('claimed', cart);
      else if (sessionValue(cart) === 'claimed') setSession('dismissed', cart);
      syncClaimLink();
      if (allowOpen && eligible(cart) && !freeLines(cart).length) open(false);
      return cart;
    }).catch(function () {});
  }
  function addSelected() {
    var variant = selectedVariant(); if (!marketAllowed || !variant || state.busy) return;
    state.busy = true; renderChoices(); showError('');
    cartRequest().then(enforce).then(function (cart) {
      if (!eligible(cart) || freeLines(cart).length) throw new Error('This offer is no longer available for this cart.');
      return request(config.routes.add, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variant.id), quantity: 1, properties: { _nsd_free_lace: 'true', Offer: 'National Sneaker Day free laces' } }] }) });
    }).then(function () { setSession('claimed'); return cartRequest(); }).then(function (cart) { state.cart = cart; close(false); notifyAndOpenMiniCart(cart); }).catch(function (error) {
      showError(error && error.description || error.message || 'We could not add your free laces. Please try again.');
    }).then(function () { state.busy = false; renderChoices(); });
  }
  function trapFocus(event) {
    if (!state.opened) return;
    if (event.key === 'Escape') { close(true); return; }
    if (event.key !== 'Tab') return;
    var focusable = root.querySelectorAll('button:not([disabled])'); if (!focusable.length) return;
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }
  root.querySelectorAll('[data-cp-nsd-dismiss]').forEach(function (button) { button.addEventListener('click', function () { close(true); }); });
  addButton.addEventListener('click', addSelected); document.addEventListener('keydown', trapFocus);
  ['cart:item-added', 'cart:refresh'].forEach(function (eventName) { document.addEventListener(eventName, function (event) { if (!event.detail || event.detail.source !== 'cp-nsd-laces') window.setTimeout(function () { refresh(true); }, 350); }); });
  var themeJquery = window.jQuery_T4NT || window.jQuery;
  if (themeJquery) themeJquery(document).on('cart.requestComplete.cpNsdLaces', function () { window.setTimeout(function () { refresh(true); }, 100); });
  document.addEventListener('click', function (event) { if (event.target.closest('[data-cart-remove],[data-quantity-selector],[data-action-change]')) window.setTimeout(function () { refresh(false); }, 800); });
  new MutationObserver(function (records) { if (state.opened) return; if (records.some(function (record) { return record.target.id === 't4s-mini_cart' && record.target.getAttribute('aria-hidden') === 'false'; })) refresh(true); }).observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['aria-hidden'] });
  window.CPNSDLaces = { refresh: refresh, open: function () { open(true); }, inWindow: inWindow };
  renderChoices(); refresh(true); window.setInterval(function () { refresh(false); }, 60000);
  window.setInterval(function () { if (!document.hidden) { placeClaims(); if (state.cart) { var v = eligible(state.cart) && !freeLines(state.cart).length && !state.opened; document.querySelectorAll('[data-cp-nsd-claim-wrap]').forEach(function (w) { w.hidden = !v; }); } tickCountdowns(); } }, 1000);
}());
